var BSS_SEL = '.bss-b2b-price-has-vat, .bss-b2b-price-no-vat, .bss-b2b-compare-price-no-vat';

function wrapEl(el) {
  if (el.querySelector('small')) return;
  var wrapped = el.innerHTML.replace(/(incl\. BTW|excl\. BTW)/g, '<small>$1</small>');
  if (wrapped !== el.innerHTML) el.innerHTML = wrapped;
}

function wrapAll() {
  document.querySelectorAll(BSS_SEL).forEach(wrapEl);
}

wrapAll();

new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    var t = m.target;
    // BSS B2B set innerHTML on a bss span → re-wrap that span
    if (m.type === 'childList' && t.nodeType === 1) {
      if (t.matches && t.matches(BSS_SEL)) {
        wrapEl(t);
      } else {
        // Child added that might contain bss spans
        m.addedNodes.forEach(function(n) {
          if (n.nodeType === 1) n.querySelectorAll(BSS_SEL).forEach(wrapEl);
        });
      }
    }
    // BSS B2B set visibility:visible → wrap all inside target
    if (m.type === 'attributes' && m.attributeName === 'style') {
      if (t.querySelectorAll) t.querySelectorAll(BSS_SEL).forEach(wrapEl);
    }
  });
}).observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style'],
});
